export const productBundles = [
  {
    id: 'bundle-1',
    name: 'Complete Home Office Setup',
    description: 'Everything you need for a productive home office',
    image: 'https://public.readdy.ai/ai/img_res/bb86d4eb325f91a08e58cab1aada1fcc.jpg',
    originalPrice: 89.96,
    bundlePrice: 69.99,
    savings: 19.97,
    products: [
      { id: 174, name: 'Desk Organizer Set' },
      { id: 161, name: 'LED Strip Lights' },
      { id: 199, name: 'Cable Organizer Set' },
      { id: 142, name: 'Coffee Mug' },
    ],
  },
  {
    id: 'bundle-2',
    name: 'Tech Essentials Bundle',
    description: 'Must-have accessories for your devices',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20tech%20accessories%20including%20wireless%20earbuds%20phone%20case%20power%20bank%20and%20charging%20cables%20arranged%20neatly%20on%20clean%20white%20surface%20with%20modern%20minimalist%20styling&width=800&height=600&seq=bundle-tech-001&orientation=landscape',
    originalPrice: 94.95,
    bundlePrice: 74.99,
    savings: 19.96,
    products: [
      { id: 159, name: 'Wireless Earbuds' },
      { id: 160, name: 'Phone Case with Card Holder' },
      { id: 162, name: 'Portable Power Bank' },
      { id: 164, name: 'USB-C Charging Cables' },
    ],
  },
  {
    id: 'bundle-3',
    name: 'Kitchen Starter Pack',
    description: 'Essential tools for every home chef',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20kitchen%20utensils%20and%20tools%20including%20silicone%20spatulas%20measuring%20spoons%20herb%20scissors%20and%20storage%20bags%20arranged%20on%20clean%20white%20marble%20countertop&width=800&height=600&seq=bundle-kitchen-001&orientation=landscape',
    originalPrice: 71.95,
    bundlePrice: 54.99,
    savings: 16.96,
    products: [
      { id: 179, name: 'Silicone Baking Mat Set' },
      { id: 180, name: 'Reusable Food Storage Bags' },
      { id: 184, name: 'Silicone Spatula Set' },
      { id: 183, name: 'Measuring Spoon Set' },
    ],
  },
  {
    id: 'bundle-4',
    name: 'Beauty Essentials Kit',
    description: 'Complete skincare and beauty routine',
    image: 'https://readdy.ai/api/search-image?query=beauty%20and%20skincare%20products%20including%20jade%20roller%20sheet%20masks%20facial%20brush%20and%20makeup%20tools%20arranged%20elegantly%20on%20clean%20white%20surface%20with%20soft%20lighting&width=800&height=600&seq=bundle-beauty-001&orientation=landscape',
    originalPrice: 63.96,
    bundlePrice: 49.99,
    savings: 13.97,
    products: [
      { id: 169, name: 'Jade Roller & Gua Sha Set' },
      { id: 170, name: 'Sheet Mask Set' },
      { id: 196, name: 'Facial Cleansing Brush' },
      { id: 194, name: 'Makeup Sponge Set' },
    ],
  },
  {
    id: 'bundle-5',
    name: 'Fitness Starter Bundle',
    description: 'Begin your fitness journey right',
    image: 'https://readdy.ai/api/search-image?query=fitness%20equipment%20including%20resistance%20bands%20yoga%20blocks%20water%20bottle%20and%20workout%20accessories%20arranged%20on%20clean%20white%20floor%20in%20bright%20minimalist%20gym%20space&width=800&height=600&seq=bundle-fitness-001&orientation=landscape',
    originalPrice: 81.97,
    bundlePrice: 64.99,
    savings: 16.98,
    products: [
      { id: 171, name: 'Resistance Bands Set' },
      { id: 198, name: 'Yoga Block Set' },
      { id: 172, name: 'Insulated Water Bottle' },
      { id: 95, name: 'Resistance Bands Premium' },
    ],
  },
  {
    id: 'bundle-6',
    name: 'Cozy Home Collection',
    description: 'Create a warm and inviting space',
    image: 'https://readdy.ai/api/search-image?query=cozy%20home%20decor%20items%20including%20throw%20pillows%20LED%20candles%20plant%20pots%20and%20picture%20frames%20arranged%20in%20warm%20inviting%20living%20room%20setting%20with%20soft%20lighting&width=800&height=600&seq=bundle-home-001&orientation=landscape',
    originalPrice: 79.96,
    bundlePrice: 62.99,
    savings: 16.97,
    products: [
      { id: 173, name: 'Throw Pillow Covers' },
      { id: 176, name: 'LED Candles' },
      { id: 175, name: 'Ceramic Plant Pots' },
      { id: 192, name: 'Picture Frame Set' },
    ],
  },
];
